import { Button, Col, Form, Input, Modal, Row, Table } from "antd";
import { NotFound } from "../../../sources/svg/svg";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useCrm } from "../../../tools/api";
import { useTranslation } from "react-i18next";
import { successMessage } from "../../../tools/toastifyShowMessage";
import { useSelector } from "react-redux";
import Loading from "../../auxiliary/loader/loading";
import { convertToJalaliWithoutTime, formatTime } from "../../../tools/tools";

const NewPurchase = () => {
  const [t] = useTranslation("global");
  const { querySPPurchaseByState, updateSPPurchaseFromPostToPrintDocState } = useCrm();

  const formData = useSelector((state) => state);

  const [isLoading, setIsLoading] = useState(false);

  const [purchaseList, setPurchaseList] = useState([]);
  const [resultSearch, setResultSearch] = useState([]);

  //state current page show Records
  const [currentPage, setCurrentPage] = useState(10);
  // state totalRecord
  const [totalRecord, setTotalRecord] = useState(0);

  const [isOpenModal, setIsOpenModal] = useState(false);

  const [bTable, setBTable] = useState([]);
  const [tTable, setTTable] = useState([]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  useEffect(() => {
    CartableListServ();
  }, [currentPage]);

  const CartableListServ = async () => {
    setIsLoading(true);
    let payload = {
      state: ["PostOffice"],
      searchconfigmodel: {
        sort: "",
        filter: "",
        entriesperpage: currentPage,
        page: 0,
        totalrowcount: 0,
      },
    };

    let response = await querySPPurchaseByState(payload);
    if (response) {
      setPurchaseList(response?.Result);
      setResultSearch(response?.Result);
      setTotalRecord(response?.searchconfigmodel?.totalrowcount);
    }
    setIsLoading(false);
  };

  const handleSearch = (e) => {
    let search = e.target.value;
    let result = purchaseList.filter((item) => {
      return Object.keys(item).some((k) => {
        return String(item[k]).toLowerCase().includes(search.toLowerCase());
      });
    });
    setResultSearch(result);
  };

  // const onSelectChange = () => {};
  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  // };

  const transToPrintHandler = async () => {
    setIsOpenModal(false);
    const payload = {
      totalrowcount: currentPage,
    };
    const response = await updateSPPurchaseFromPostToPrintDocState(payload);
    if (!response?.HasError) {
      successMessage("انتقال با موفقیت انجام پذیرفت");
      CartableListServ();
    }
  };
  return (
    <>
      <div className="g-body-format-page">
        <div className="holder-form-filter">
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item className="input-normal" label="جستجو">
                  <Input placeholder="جستجو" dir="ltr" allowClear onChange={handleSearch} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="holder-table">
          <Table
            // rowSelection={rowSelection}
            className="tbl-normal"
            columns={[
              {
                title: "کدملی",
                dataIndex: "certno",
                key: "certno",
                width: 150,
              },

              {
                title: "نام",
                dataIndex: "fname",
                key: "fname",
                width: 150,
              },
              {
                title: "نام خانوادگی",
                dataIndex: "lname",
                key: "lname",
                width: 150,
              },

              {
                title: "نام پدر",
                dataIndex: "fathername",
                key: "fathername",
                width: 150,
              },
              {
                title: "تاریخ خرید",
                dataIndex: "purchasedate",
                key: "purchasedate",
                width: 150,
                sorter: (a, b) => {
                  return new Date(a.purchasedate.props["data-date"]) - new Date(b.purchasedate.props["data-date"]);
                },
                showSorterTooltip: false,
              },
            ]}
            locale={{
              emptyText: (
                <>
                  <NotFound text={"رکوردی یافت نشد."} />
                </>
              ),
            }}
            pagination={{
              className: "page-pagination",
              // position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
              onChange: (page, pageSize) => {
                setCurrentPage(pageSize);
              },
              pageSize: currentPage,
              align: "start",
              current: 1,
              total: currentPage,
              showSizeChanger: true,
            }}
            dataSource={resultSearch.map((item, key) => ({
              key: key,
              certno: item.stR_CertNo,
              fname: item.stR_FName,
              lname: item.stR_LName,
              fathername: item.stR_FatherName,
              purchasedate: (
                <span dir="ltr" data-date={item?.dtE_PurchaseDate}>
                  {convertToJalaliWithoutTime(item?.dtE_PurchaseDate)} - {formatTime(new Date(item?.dtE_PurchaseDate))}
                </span>
              ),
            }))}
          ></Table>
        </div>
      </div>
      <div className="g-footer-format-page">
        <div className="holder-button">
          <Button
            onClick={() => {
              resultSearch.length > 0 && setIsOpenModal(true);
            }}
            htmlType="submit"
            className="btn-normal btn-aptel"
            type="primary"
            danger
          >
            انتقال به کارتابل چاپ سند
          </Button>
        </div>
      </div>

      <Modal centered className="modal-confirm-global" footer={[]} open={isOpenModal} onCancel={() => setIsOpenModal(false)}>
        <div className="modal-confirm">
          <div className="modal-body">
            <div className="confirm-body">
              <div className="holder-icon">
                <InfoCircleOutlined />
              </div>
              <p>
                تعداد <span>{currentPage}</span> رکورد انتخاب شده است
              </p>
            </div>
          </div>
          <div className="modal-footer">
            <div className="holder-button">
              <Button className="btn-normal btn-green" onClick={transToPrintHandler}>
                تایید
              </Button>
              <Button className="btn-normal" onClick={() => setIsOpenModal(false)}>
                انصراف
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      <Loading isOpen={isLoading} />
    </>
  );
};

export default NewPurchase;
